"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRange = void 0;

var _getRanges = require("./get-ranges");

var _isInRange = require("./is-in-range");

/**
 * @description
 * It returns a range for the specified position
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#getRange
 * @param {skybase-components.sb-ipv4-input.utils#Range} range
 * @param {Number} position
 * @return {skybase-components.sb-ipv4-input.utils#Range}
 */
var getRange = function getRange(text, position) {
  return (0, _getRanges.getRanges)(text).find(function (range) {
    return (0, _isInRange.isInRange)(range, position);
  });
};

exports.getRange = getRange;
//# sourceMappingURL=get-range.js.map